<template>
	<article class="small-12 listing residentListing bgWhite border light borderRadius4 flex vertical-align animated fadeIn" v-if="resident">
		<router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: resident.id } }" class="flex small-12">
			<div class="small-12 large-4 columns flex vertical-align">
				<p class="small-12 text-overflow transition flex vertical-align">
					<picture class="avatar round flex justify-center vertical-align bgPrimaryBlue cWhite" :style="avatarBackgroundStyle" v-if="resident.links.avatar"></picture> 
					<picture class="avatar round flex justify-center vertical-align bgPrimaryBlue cWhite" v-else>
						<span>{{resident.attributes.contact_information.first_name | abbreviateName}} {{resident.attributes.contact_information.last_name | abbreviateName}}</span>
					</picture> 
					{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align">
				<p class="small-12 text-overflow">
					<span class="badge bgYellow borderRadius50" v-if="resident.attributes.site_enrollment.enroll_resident && !resident.attributes.referral.registered">Invited</span>
					<span class="badge cGreen borderRadius50" v-else-if="resident.attributes.referral.registered">Enrolled</span>
					<span class="badge cGrey borderRadius50" v-else>Not Enrolled</span>
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align">
				<p class="small-12 text-overflow cMedium transition" v-if="unit">
					{{unit.attributes.number}}
				</p>
				<p class="small-12 text-overflow cMedium transition" v-else>
					--
				</p>
			</div>
			<div class="small-12 large-4 columns flex vertical-align justify-between">
				<p class="auto text-overflow cMedium transition" v-if="lease">
					${{lease.attributes.rent.amount | convertCentsToDollars}}/mo.
				</p>
				<p class="auto text-overflow cMedium transition" v-else>
					--
				</p>
				<a class="border borderRadius4 flex vertical-align justify-center viewButton cMedium">
					<i class="material-icons">navigate_next</i>
				</a>
			</div>
		</router-link>
	</article>
</template>

<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
	import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Resident',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			MoneyConversions,
			AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			resident: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			lease: null,
			unit: null,
			openMenuDropdown: false,
			isActive: false,
			future_item: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			resident: {

				immediate: true, // Load on created
				handler(resident) {

					// Get the lease
					if (resident && resident.relationships.lease) this.getLease();

					// Get the unit
					if (resident) this.getUnit();

				}

			}

		},

		/*
		**  Do this first
		*/

		created() {

			window.addEventListener("click", this.closeEditMenuDropdown);

		},

		/*
		**  Do this last
		*/

		beforeDestroy() {

			window.removeEventListener("click", this.closeEditMenuDropdown);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			getLease: function() {

				propertiesModel.doc(this.resident.relationships.property).collection('leases').doc(this.resident.relationships.lease).get()
				.then(doc => {

					if (!doc.exists) return;

					// Add to the prop
					this.lease = doc.data();

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Get Lease - Residents Listing',
						errorType: 'Firestore Database',
						section: 'Property Residents',
						component: 'Resident',
						error: error
					});

				});

			},

			getUnit: function() {

				propertiesModel.doc(this.resident.relationships.property).collection('units').doc(this.resident.relationships.unit).get()
				.then(doc => {

					if (!doc.exists) return;

					// Add to the prop
					this.unit = doc.data();

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Get Unit - Residents Listing',
						errorType: 'Firestore Database',
						section: 'Property Residents',
						component: 'Resident',
						error: error
					});

				});

			},

			throwDeleteModal: function() {

				//

			},

			openEditMenuDropdown: function() {

				// Set the prop
				if (!this.openMenuDropdown) {

					// Open menu
					this.openMenuDropdown = true;

					// Set the z-index of the unit
					this.isActive = true;

				} else {

					// Open menu
					this.openMenuDropdown = false;

					// Set the z-index of the unit
					this.isActive = false;

				}

			},

			closeEditMenuDropdown: function(e) {

		    	if (!this.$el.contains(e.target)) {

		    		// Close menu
		    		this.openMenuDropdown = false;

		    		// Set the z-index of the unit
					this.isActive = false;

		    	}

		    }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			avatarBackgroundStyle: function() {

				return 'background:url(' + this.resident.links.avatar + ') no-repeat center/cover;'

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>